import {getFloorEcology} from '../data/floorEcology';
import {getFuchiFloor} from '../data/fuchiFloors';
import FloorEcologyContent from './FloorEcologyContent';
import SpecimenLocalization from './SpecimenLocalization';

export default function FloorEcology({floor, lang = 'zh-Hant'}) {
  const data = getFuchiFloor(floor);
  const ecology = getFloorEcology(data);

  return (
    <section
      className={`floor-ecology ${ecology.safe ? 'is-safe' : ''}`}
      data-floor={floor}
      aria-label={
        lang === 'en'
          ? `Floor ${floor} scene and ecology record`
          : `${floor}層場景與生態記錄`
      }
    >
      <style>{`
        .tower-floor-panel__tags,.specimen-cabinet__head {
          display: none !important;
        }
        .specimen-cabinet--embedded {
          margin-top: 1rem !important;
          padding-top: 0 !important;
          border-top: 0 !important;
        }
        .specimen-cabinet--embedded::before {
          display: none;
        }
        .floor-ecology {
          position: relative;
          margin: 0;
          padding: 0;
        }
        .floor-ecology__header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: .7rem;
          margin-bottom: .7rem;
        }
        .floor-ecology__identity {
          display: flex;
          align-items: center;
          gap: .55rem;
          min-width: 0;
        }
        .floor-ecology__identity::before {
          content: "";
          flex: 0 0 3px;
          width: 3px;
          height: 24px;
          border-radius: 10px;
          background: linear-gradient(#f0d476,#9b2821);
          box-shadow: 0 0 12px rgba(220,174,72,.35);
        }
        .floor-ecology__identity span {
          display: block;
          color: #d7b967;
          font: 600 .54rem "Cormorant Garamond";
          letter-spacing: .18em;
        }
        .floor-ecology__identity strong {
          display: block;
          margin-top: .08rem;
          color: #e6dcc8;
          font: 500 .62rem "Noto Serif JP";
          letter-spacing: .08em;
        }
        .floor-ecology__count {
          flex: 0 0 auto;
          padding: .25rem .48rem;
          border: 1px solid rgba(142,116,74,.42);
          border-radius: 4px;
          color: #968b79;
          background: rgba(5,5,5,.24);
          font: 500 .46rem "Noto Serif JP";
          letter-spacing: .06em;
        }
        .floor-ecology.is-safe .floor-ecology__count {
          color: #eed67e;
          border-color: rgba(238,214,126,.42);
        }
        .floor-ecology__scene {
          margin-bottom: .75rem;
          padding: .68rem;
          border: 1px solid rgba(209,174,94,.2);
          border-radius: 7px;
          background:
            linear-gradient(135deg,rgba(93,67,30,.18),transparent 55%),
            rgba(6,6,6,.28);
        }
        .floor-ecology__section-title {
          display: flex;
          align-items: center;
          gap: .48rem;
          margin-bottom: .52rem;
        }
        .floor-ecology__section-title span {
          color: #b89958;
          font: 600 .45rem "Cormorant Garamond";
          letter-spacing: .2em;
        }
        .floor-ecology__section-title span::after {
          content: "";
          display: inline-block;
          width: 24px;
          height: 1px;
          margin-left: .45rem;
          vertical-align: middle;
          background: rgba(190,153,79,.34);
        }
        .floor-ecology__section-title b {
          color: #a79a85;
          font: 500 .5rem "Noto Serif JP";
          letter-spacing: .08em;
        }
        .floor-ecology__scene-list {
          display: grid;
          grid-template-columns: repeat(3,minmax(0,1fr));
          gap: .35rem;
        }
        .floor-ecology__scene-item {
          min-width: 0;
          padding: .42rem .38rem;
          border: 1px solid rgba(201,179,130,.12);
          border-radius: 4px;
          background: rgba(255,255,255,.025);
        }
        .floor-ecology__scene-item i {
          display: block;
          margin-bottom: .18rem;
          color: #775d39;
          font: 600 .39rem "Cormorant Garamond";
          font-style: normal;
          letter-spacing: .12em;
        }
        .floor-ecology__scene-item span {
          display: block;
          overflow: hidden;
          color: #d5c8af;
          font: 500 .48rem/1.45 "Noto Serif JP";
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .floor-ecology__creatures {
          display: grid;
          gap: .38rem;
        }
        .floor-ecology__creature {
          position: relative;
          display: grid;
          grid-template-columns: 34px minmax(0,1fr);
          gap: .58rem;
          align-items: center;
          min-height: 46px;
          padding: .42rem .5rem;
          overflow: hidden;
          border: 1px solid rgba(105,142,157,.19);
          border-radius: 6px;
          background:
            linear-gradient(90deg,rgba(12,39,50,.48),rgba(6,8,9,.16));
        }
        .floor-ecology__creature::after {
          content: "";
          position: absolute;
          top: 0;
          right: 0;
          width: 28%;
          height: 1px;
          background:
            linear-gradient(90deg,transparent,rgba(125,195,218,.3));
        }
        .floor-ecology__glyph {
          width: 32px;
          height: 28px;
          display: grid;
          place-items: center;
          border-right: 1px solid rgba(135,183,198,.16);
          color: #9ed9eb;
          text-shadow: 0 0 10px currentColor;
          font: 1.2rem serif;
          font-style: normal;
          animation:
            ecology-swim 3.2s var(--delay) ease-in-out infinite;
        }
        .floor-ecology__glyph--spirit {
          color: #d7b9ff;
          animation-name: ecology-float;
        }
        .floor-ecology__glyph--urchin,
        .floor-ecology__glyph--shell,
        .floor-ecology__glyph--crab {
          color: #dcb06b;
        }
        .floor-ecology__glyph--cat {
          color: #d8c8a8;
          font-size: .7rem;
        }
        .floor-ecology__creature-copy {
          min-width: 0;
        }
        .floor-ecology__creature strong {
          display: block;
          color: #e8decb;
          font: 500 .59rem "Noto Serif JP";
          letter-spacing: .04em;
        }
        .floor-ecology__creature small {
          display: block;
          margin-top: .13rem;
          overflow: hidden;
          color: #91897c;
          font: .47rem/1.45 "Noto Serif JP";
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .floor-ecology__safe {
          display: grid;
          grid-template-columns: 34px minmax(0,1fr);
          gap: .6rem;
          align-items: center;
          padding: .62rem;
          border: 1px solid rgba(237,206,105,.35);
          border-radius: 6px;
          background:
            linear-gradient(90deg,rgba(76,56,14,.28),transparent),
            rgba(7,7,6,.24);
        }
        .floor-ecology__safe-mark {
          width: 31px;
          height: 31px;
          display: grid;
          place-items: center;
          border: 1px solid rgba(240,211,114,.58);
          border-radius: 50%;
          color: #f0d372;
          font: 500 .65rem "Noto Serif JP";
        }
        .floor-ecology__safe strong {
          display: block;
          margin-bottom: .16rem;
          color: #f0d372;
          font: 500 .55rem "Noto Serif JP";
          letter-spacing: .08em;
        }
        .floor-ecology__safe span {
          display: block;
          color: #a99b7d;
          font: .48rem/1.6 "Noto Serif JP";
        }
        .specimen-cabinet__grid {
          position: relative;
          gap: .42rem !important;
          margin-top: .82rem !important;
          padding-top: .78rem;
          border-top: 1px solid rgba(235,221,185,.14);
        }
        .specimen-cabinet__grid::before {
          content: "RECOVERABLE SPECIMENS";
          display: block;
          margin-bottom: .05rem;
          color: #a98d52;
          font: 600 .48rem "Cormorant Garamond";
          letter-spacing: .17em;
        }
        .specimen-cabinet__item {
          min-height: 46px !important;
          padding: .48rem .52rem !important;
          border-radius: 6px;
          background:
            linear-gradient(90deg,rgba(41,32,20,.44),rgba(5,5,5,.3))
            !important;
        }
        .specimen-cabinet__item.is-hidden:hover,
        .specimen-cabinet__item.is-selected {
          transform: translateX(3px) !important;
        }
        .specimen-cabinet__detail {
          margin-top: .48rem !important;
          padding: .5rem .62rem !important;
          border-left: 0 !important;
          border-radius: 5px;
          color: #998e7d !important;
          background: rgba(7,7,7,.36) !important;
        }
        @keyframes ecology-swim {
          50% {
            transform: translateX(4px) rotate(-4deg);
            opacity: .68;
          }
        }
        @keyframes ecology-float {
          50% {
            transform: translateY(-4px) scale(1.08);
            opacity: .58;
          }
        }
        @media (max-width: 800px) {
          .specimen-cabinet--embedded {
            margin-top: .75rem !important;
          }
          .floor-ecology__scene-list {
            grid-template-columns: 1fr;
            gap: .28rem;
          }
          .floor-ecology__scene-item {
            display: grid;
            grid-template-columns: 22px minmax(0,1fr);
            align-items: center;
            padding: .36rem .4rem;
          }
          .floor-ecology__scene-item i {
            margin: 0;
          }
          .floor-ecology__creature {
            min-height: 41px;
            grid-template-columns: 28px minmax(0,1fr);
          }
          .floor-ecology__glyph {
            width: 27px;
            font-size: 1rem;
          }
          .floor-ecology__creature small {
            font-size: .43rem;
          }
          .specimen-cabinet__item {
            min-height: 42px !important;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .floor-ecology__glyph {
            animation: none;
          }
        }
      `}</style>

      <SpecimenLocalization floor={floor} lang={lang} />
      <FloorEcologyContent
        data={data}
        ecology={ecology}
        floor={floor}
        lang={lang}
      />
    </section>
  );
}